import React, { memo } from 'react'
import { useTheme } from '@mui/material'
import { Shimmer } from 'shimmer-from-structure'

/**
 * Theme-aware Shimmer with subtle colors for a softer loading effect.
 * Wraps shimmer-from-structure with backgroundColor and shimmerColor
 * that adapt to light/dark mode.
 */
const SubtleShimmer: React.FC<React.ComponentProps<typeof Shimmer>> = ({ shimmerColor, backgroundColor, ...props }) => {
    const theme = useTheme()
    const isDark = theme.palette.mode === 'dark'

    const subtleShimmerColor = shimmerColor ?? (isDark ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.5)')
    const subtleBackgroundColor = backgroundColor ?? (isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.05)')

    return (
        <Shimmer
            {...props}
            shimmerColor={subtleShimmerColor}
            backgroundColor={subtleBackgroundColor}
        />
    )
}

export default memo(SubtleShimmer)
